module.exports = __webpack_public_path__ + "static/media/RealTimeCommunication_Elec_005.00544b00.png";